import React, { useState } from "react";
import { HiOutlineChevronDown, HiOutlineChevronUp, HiCheckCircle } from "react-icons/hi"; // Import the dropdown icons
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import nodeinstance from "../../../../../nodeInstance";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Repatriation({
  repatration,
  repatrationdata,
  updateNew,
  isLocalExit = false,
  baseEndpoint = '/mobilization',
  setRepatriationAmount,
  setRepatriationSaved,
  setSelectedRepatrationType,
  trigger,
  setTrigger,
}) {

  const [rowData, setRowsData] = useState([]);

  const handleChange = (event, index) => {
    const { name, value: inputValue } = event.target;
    const updatedRowsData = [...rowData];
    updatedRowsData[index] = {
      ...updatedRowsData[index], // Copy existing properties
      [name]: inputValue,
      // date: getDatevalue(),
    };
    setRowsData(updatedRowsData);

    // Recalculate repatriation amount in real-time when cost or Basicdays changes
    if ((name === 'cost' || name === 'Basicdays') && setRepatriationAmount && highlightedDiv && value) {
      const totalCost = updatedRowsData.reduce((total, item) => {
        const basicDays = parseFloat(item.Basicdays || 365);
        const dailyCost = parseFloat(item.cost || 0) / basicDays;
        const calculatedCost = dailyCost * value;  // value here is tenure days from state
        return total + calculatedCost;
      }, 0);
      setRepatriationAmount(Math.round(totalCost));

      // Mark as not saved
      if (setRepatriationSaved) {
        setRepatriationSaved(false);
      }
    }
  };

  const handleAddRow = () => {
    setRowsData((prevRowsData) => [
      ...prevRowsData,
      {
        // Don't include id - let database auto-increment on save
        name: "",
        cost: "",
        Basicdays: "0", // Fixed cost rows have 0 basis days (no formula calculation)
        rate_category_id: 2,
        rate_category_item_id: null, // No master reference for custom rows
        disabled: false,
        isFromMaster: false, // Custom row - description is editable
        isFixed: true, // Mark as fixed cost (no formula calculation)
        isNewlyAdded: true, // Temporary flag for saving to DB
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updatedRowsData = rowData.filter((_, i) => i !== index);
    setRowsData(updatedRowsData);
  };

  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const [storeData, setStoreData] = useState();

  // Date toggle state: true = Contract Expiry (demobilization_date), false = Today
  // Initialize from saved value or default to true
  const [useContractDate, setUseContractDate] = useState(
    repatrationdata?.repatriationCalculationMode !== undefined
      ? repatrationdata.repatriationCalculationMode
      : true
  );

  // Update state when repatrationdata changes
  useEffect(() => {
    if (repatrationdata?.repatriationCalculationMode !== undefined) {
      setUseContractDate(repatrationdata.repatriationCalculationMode);
    }
  }, [repatrationdata?.repatriationCalculationMode]);

  // Initialize with saved repatrationType if exists, else default to 1
  const [highlightedDiv, setHighlightedDiv] = useState(
    repatrationdata?.repatrationType ||
    (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType) ||
    1
  );
  const [value, setValue] = useState("");

  // Load saved selection when data is available
  useEffect(() => {
    const storeNewData = repatrationdata?.data;
    console.log(storeData)
    if (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]) {
      setHighlightedDiv(storeData[0]?.selectedType || 1);
      setValue(storeData[0]?.TenureDays);
    } else if (repatrationdata?.repatrationType && storeNewData?.[0] && !value) {
      // Calculate tenure days based on saved repatrationType
      const savedType = repatrationdata.repatrationType;
      let tenureDays;
      if (savedType === 1) {
        tenureDays = calculateDaysBetweenDates(
          storeNewData[0]?.demobilization_date,
          storeNewData[0]?.iqama_expiry_date_g
        );
      } else if (savedType === 2) {
        tenureDays = calculateDaysBetweenDates(
          storeNewData[0]?.demobilization_date,
          storeNewData[0]?.Newiqamaexpiry
        );
      } else if (savedType === 3) {
        tenureDays = calculateDaysBetweenDates(
          storeNewData[0]?.demobilization_date,
          storeNewData[0]?.end_date
        );
      }

      setHighlightedDiv(savedType);
      setValue(tenureDays);

      // Also set parent state
      if (setSelectedRepatrationType) {
        setSelectedRepatrationType(savedType);
      }
    }
  }, [repatrationdata, storeData]);
  // TenureDays
  const handleHighlightChange = (divId, tenureDays) => {
    setHighlightedDiv(divId);
    setValue(tenureDays);

    // Calculate repatriation amount in real-time
    if (setSelectedRepatrationType) {
      setSelectedRepatrationType(divId);
    }

    // Calculate total repatriation cost based on tenure days
    if (setRepatriationAmount && rowData.length > 0) {
      const totalCost = rowData.reduce((total, item) => {
        // Fixed cost rows: use direct cost value
        if (item.isFixed === true) {
          return total + parseFloat(item.cost || 0);
        }
        // Formula-based rows: calculate using Basicdays
        const basicDays = parseFloat(item.Basicdays || 365);
        const dailyCost = parseFloat(item.cost || 0) / basicDays;
        const calculatedCost = dailyCost * tenureDays;
        return total + calculatedCost;
      }, 0);
      setRepatriationAmount(Math.round(totalCost));
    }

    // Mark as not saved when selection changes
    if (setRepatriationSaved) {
      setRepatriationSaved(false);
    }
  };
  const token = localStorage.getItem("nodeToken");

  const getData = async () => {
    try {
      // Use correct endpoint based on isLocalExit flag
      const getRepatrationEndpoint = isLocalExit
        ? `${baseEndpoint}/getRepatrationNew/${storeNewData[0]?.candidate_id}`
        : `/mobilization/getRepatrationNew/${storeNewData[0]?.candidate_id}`;

      const repatraionOldEndpoint = isLocalExit
        ? `${baseEndpoint}/repatraionOld`
        : "/mobilization/repatraionOld";

      let url =
        repatrationdata?.Final_exit_status === "OPSAUTHORISED"
          ? getRepatrationEndpoint
          : repatrationdata.repatration_Status === "DONE" &&
            repatrationdata.repatrationType === highlightedDiv
            ? getRepatrationEndpoint
            : repatraionOldEndpoint;

      console.log("Fetching repatriation data from:", url);
      const response = await nodeinstance.get(`${url}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setStoreData(response.data.data);
        const newData = response.data.data.map((data, index) => ({
          // Don't include id - let database auto-increment on save
          name: data.name,
          rate_category_id: 2,
          rate_category_item_id: data.rate_category_item_id || data.id, // Track master item reference
          disabled: repatrationdata?.Final_exit_status === "OPSAUTHORISED", // Only disable if OPS AUTHORISED
          isFromMaster: true, // Mark as master data - description not editable
          cost: data.cost,
          Basicdays: data.Basicdays || "365", // Include Basicdays from saved data or default
          isFixed: data.isFixed === true || data.isFixed === 1, // Include isFixed from database
        }));
        setRowsData(newData);
      }
    } catch (error) {
      console.log("error to be printed here in console", error);
    }
  };

  useEffect(() => {
    if (
      highlightedDiv != "" ||
      repatrationdata?.Final_exit_status === "OPSAUTHORISED"
    ) {
      getData();
    } else {
      console.log(".............................");
    }
  }, [highlightedDiv, repatrationdata]);

  // Recalculate repatriation amount when rowData changes
  useEffect(() => {
    if (highlightedDiv && value && rowData.length > 0 && setRepatriationAmount) {
      const totalCost = rowData.reduce((total, item) => {
        const isFixed = item.isFixed === true;
        const basicDays = parseFloat(item.Basicdays || 365);
        const dailyCost = parseFloat(item.cost || 0) / basicDays;
        const calculatedCost = dailyCost * value;
        const itemTotal = isFixed ? parseFloat(item.cost || 0) : calculatedCost;
        return total + itemTotal;
      }, 0);
      setRepatriationAmount(Math.round(totalCost));
    }
  }, [rowData, value]);

  var titles = [
    "S.NO",
    "Description",
    "COST",
    "BASIS DAYS",
    `${highlightedDiv === 1
      ? "BALANCE TENURE AS PER IQAMA EXPIRY"
      : highlightedDiv === 2
        ? " BALANCE TENURE AS PER  NEW IQAMA EXPIRY DATE"
        : highlightedDiv === 3
          ? " BALANCE TENURE  AS PER CONTRACT"
          : ""
    }`,
  ];

  function calculateDaysBetweenDates(startDate, endDate, useToday = false) {
    // Return null if endDate is missing
    if (!endDate) {
      return null;
    }

    // Use today's date if useToday is true, otherwise use startDate
    const effectiveStartDate = useToday ? new Date() : startDate;

    // Return null if startDate is missing and not using today
    if (!useToday && !startDate) {
      return null;
    }

    const start = new Date(endDate);
    const end = new Date(effectiveStartDate);

    // Check if dates are valid
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return null;
    }

    const differenceInMilliseconds = start - end;
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    return Math.round(differenceInDays);
  }
  const storeNewData = repatrationdata?.data;
  console.log("........storeNewData,storeNewData", storeNewData);
  console.log("🎯 Current value state:", value);
  console.log("🎯 Current highlightedDiv:", highlightedDiv);
  console.log("🎯 Current useContractDate:", useContractDate);

  // Set default value when component mounts or data changes
  // Unified useEffect: Calculate value on initial load, card change, and radio change
  useEffect(() => {
    console.log('🔍 useEffect triggered:', {
      hasStoreNewData: !!storeNewData,
      hasData: !!storeNewData?.[0],
      highlightedDiv,
      useContractDate,
      rowDataLength: rowData?.length
    });

    if (storeNewData && storeNewData[0] && highlightedDiv) {
      let calculatedTenureDays;

      // Calculate based on selected card and radio button state
      // When useContractDate is true: use contract end_date as start
      // When useContractDate is false: use today as start (pass null so calculateDaysBetweenDates uses today)
      const startDate = useContractDate ? storeNewData[0]?.end_date : null;

      if (highlightedDiv === 1) {
        // Card 1: CONTRACT EXPIRY mode => end_date - iqama_expiry, TODAY mode => iqama_expiry - today
        if (useContractDate) {
          // CONTRACT END DATE - IQAMA EXPIRY DATE
          calculatedTenureDays = calculateDaysBetweenDates(
            storeNewData[0]?.iqama_expiry_date_g,
            storeNewData[0]?.end_date,
            false
          );
        } else {
          // IQAMA EXPIRY DATE - Today
          calculatedTenureDays = calculateDaysBetweenDates(
            null,
            storeNewData[0]?.iqama_expiry_date_g,
            true
          );
        }
        console.log('📅 Card 1 calculation:', {
          mode: useContractDate ? 'CONTRACT EXPIRY' : 'TODAY',
          formula: useContractDate ? 'end_date - iqama_expiry' : 'iqama_expiry - today',
          result: calculatedTenureDays
        });
      } else if (highlightedDiv === 2) {
        // Card 2: CONTRACT EXPIRY mode => end_date - new_iqama_expiry, TODAY mode => new_iqama_expiry - today
        if (useContractDate) {
          // CONTRACT END DATE - NEW IQAMA EXPIRY DATE
          calculatedTenureDays = calculateDaysBetweenDates(
            storeNewData[0]?.Newiqamaexpiry,
            storeNewData[0]?.end_date,
            false
          );
        } else {
          // NEW IQAMA EXPIRY DATE - Today
          calculatedTenureDays = calculateDaysBetweenDates(
            null,
            storeNewData[0]?.Newiqamaexpiry,
            true
          );
        }
      } else if (highlightedDiv === 3) {
        // Card 3: Both modes => CONTRACT END DATE - Today
        calculatedTenureDays = calculateDaysBetweenDates(
          null,
          storeNewData[0]?.end_date,
          true
        );
      }

      // Always update value if calculation is valid
      if (calculatedTenureDays !== null && calculatedTenureDays !== undefined) {
        console.log('✅ Setting value:', calculatedTenureDays);
        setValue(calculatedTenureDays);

        // Set the selected repatriation type
        if (setSelectedRepatrationType) {
          setSelectedRepatrationType(highlightedDiv);
        }

        // Also update repatriation amount when value changes
        if (setRepatriationAmount && rowData.length > 0) {
          const totalCost = rowData.reduce((total, item, index) => {
            const basicDays = parseFloat(item.Basicdays || 365);
            const dailyCost = parseFloat(item.cost || 0) / basicDays;
            const calculatedCost = dailyCost * calculatedTenureDays;
            const itemTotal = item.isFixed ? parseFloat(item.cost || 0) : calculatedCost;
            return total + itemTotal;
          }, 0);
          setRepatriationAmount(Math.round(totalCost));
        }
      }
    }
  }, [useContractDate, storeNewData, highlightedDiv, rowData, setRepatriationAmount, setSelectedRepatrationType, repatrationdata]);

  const navigate = useNavigate();

  const SaveChanges = async () => {
    // setTriggerNEW(!triggerNew);

    try {
      console.log("object to be seen in the console", rowData);

      // Calculate totalcost with detailed logging
      const saveTotalCost = rowData.reduce((total, listItem, index) => {
        const isFixed = listItem.isFixed === true;
        const basicDays = parseFloat(listItem.Basicdays || 365);
        const dailyCost = parseFloat(listItem.cost || 0) / basicDays;
        const calculatedCost = dailyCost * value;
        const itemTotal = isFixed ? parseFloat(listItem.cost || 0) : calculatedCost;
        return total + itemTotal;
      }, 0);

      let reqObj = {
        employee_id: storeNewData[0]?.candidate_id,
        repatrationStatus: "DONE",
        repatraion: rowData,
        totalcost: Math.round(saveTotalCost),
        selected_type: highlightedDiv,
        repatrationType: highlightedDiv,
        repatriationCalculationMode: useContractDate,
        TenureDays:
          highlightedDiv === 1
            ? calculateDaysBetweenDates(
              storeNewData && repatrationdata?.demobilization_date,
              storeNewData && storeNewData[0]?.iqama_expiry_date_g
            )
            : highlightedDiv === 2
              ? calculateDaysBetweenDates(
                storeNewData && repatrationdata?.demobilization_date,
                storeNewData && storeNewData[0]?.Newiqamaexpiry
              )
              : highlightedDiv === 3
                ? calculateDaysBetweenDates(
                  storeNewData && repatrationdata?.demobilization_date,
                  storeNewData && storeNewData[0]?.end_date
                )
                : 0,
      };
      const saveEndpoint = isLocalExit
        ? `${baseEndpoint}/saverepatrationdata`
        : `/mobilization/saverepatrationdata`;

      const response = await nodeinstance.post(
        saveEndpoint,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        // Mark as saved
        if (setRepatriationSaved) {
          setRepatriationSaved(true);
        }

        // Trigger data refresh to update Financial Statement
        if (setTrigger) {
          setTrigger(!trigger);
        }

        alert(response.data?.message || "Repatriation data saved successfully");
        const redirectPath = isLocalExit ? "/dashboard/settlement-preview" : "/dashboard/final-exit";
        // navigate(redirectPath);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  console.log("rowData TO BE SEEN IN CONSOLE", rowData, storeData);
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <button
        className="w-full flex items-center justify-between px-6 py-4 bg-gradient-to-r from-gray-50 to-white hover:from-gray-100 hover:to-gray-50 transition-all duration-200 group"
        onClick={toggleCollapse}
        aria-expanded={!isCollapsed}
        aria-controls="collapseWithScrollbar"
      >
        <div className="flex items-center space-x-3">
          <div className={`transform transition-transform duration-200 ${isCollapsed ? "" : "rotate-180"}`}>
            <HiOutlineChevronDown className="w-5 h-5 text-gray-600" />
          </div>
          <span className="text-sm font-bold text-gray-800 uppercase tracking-wide">
            Repatriation
          </span>
        </div>
        <span className="text-xs text-gray-500 uppercase tracking-wider font-medium">
          {isCollapsed ? "Click to Expand" : "Click to Collapse"}
        </span>
      </button>
      <div
        className={`transition-all duration-300 ease-in-out ${isCollapsed ? "max-h-0 opacity-0" : "max-h-[5000px] opacity-100"
          } overflow-hidden`}
        id="collapseWithScrollbar"
      >
        <div className="p-6 bg-white">
          <>
            {/* Date Radio Buttons */}
            <div className="mb-6 flex items-center gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <span className="text-sm font-semibold text-gray-700 uppercase">Calculate Balance From:</span>

              {/* Radio Buttons */}
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="dateCalculation"
                    checked={useContractDate}
                    onChange={() => setUseContractDate(true)}
                    disabled={repatrationdata?.Final_exit_status === "OPSAUTHORISED"}
                    className="w-4 h-4 accent-red-600 bg-gray-100 border-gray-300 focus:ring-0 focus:outline-none"
                    style={{ accentColor: '#dc2626' }}
                  />
                  <span className={`text-xs font-medium uppercase ${useContractDate ? 'text-gray-900 font-bold' : 'text-gray-600'}`}>
                    Contract Expiry
                  </span>
                </label>

                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="dateCalculation"
                    checked={!useContractDate}
                    onChange={() => setUseContractDate(false)}
                    disabled={repatrationdata?.Final_exit_status === "OPSAUTHORISED"}
                    className="w-4 h-4 accent-red-600 bg-gray-100 border-gray-300 focus:ring-0 focus:outline-none"
                    style={{ accentColor: '#dc2626' }}
                  />
                  <span className={`text-xs font-medium uppercase ${!useContractDate ? 'text-gray-900 font-bold' : 'text-gray-600'}`}>
                    Today
                  </span>
                </label>
              </div>

              {/* Info Icon with Tooltip */}
              <div className="relative group">
                <button
                  type="button"
                  className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 text-white hover:bg-blue-600 transition-all"
                  title="Toggle Information"
                >
                  <span className="text-sm font-bold">?</span>
                </button>
                <div className="absolute left-0 top-8 w-80 p-4 bg-white border-2 border-blue-500 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  <div className="mb-3">
                    <p className="text-sm font-bold text-gray-900 mb-2">📅 Balance Calculation Mode:</p>
                  </div>
                  <div className="space-y-3 text-xs text-gray-700">
                    <div className="p-2 bg-gray-50 rounded">
                      <p className="font-semibold text-gray-900 mb-1">🔹 Contract Expiry (Default):</p>
                      <p>Calculates balance days from <span className="font-bold text-blue-600">Demobilization Date</span> to the expiry date.</p>
                      <p className="mt-1 text-gray-600 italic">Use: Standard calculation for contract-based tenure</p>
                    </div>
                    <div className="p-2 bg-blue-50 rounded">
                      <p className="font-semibold text-gray-900 mb-1">🔹 Today:</p>
                      <p>Calculates balance days from <span className="font-bold text-red-600">Current Date</span> to the expiry date.</p>
                      <p className="mt-1 text-gray-600 italic">Use: Real-time remaining days calculation</p>
                    </div>
                  </div>
                  <div className="mt-3 pt-3 border-t border-gray-200">
                    <p className="text-xs text-gray-600">
                      <span className="font-semibold">Affects:</span> All 3 balance tenure cards (IQAMA, New IQAMA, Contract)
                    </p>
                  </div>
                </div>
              </div>

              <span className="text-xs text-gray-500 italic ml-auto">
                {useContractDate ? '(From Contract End Date)' : '(From Today\'s Date)'}
              </span>
            </div>

            <div className="flex flex-wrap gap-4">
              {/* Card 1: Balance Tenure as per IQAMA Expiry */}
              <div
                onClick={() => {
                  if (repatrationdata?.Final_exit_status !== "OPSAUTHORISED" && storeNewData?.[0]?.iqama_expiry_date_g) {
                    let tenureDays;
                    if (useContractDate) {
                      // CONTRACT END DATE - IQAMA EXPIRY DATE
                      tenureDays = calculateDaysBetweenDates(
                        storeNewData[0]?.iqama_expiry_date_g,
                        storeNewData[0]?.end_date,
                        false
                      );
                    } else {
                      // IQAMA EXPIRY DATE - Today
                      tenureDays = calculateDaysBetweenDates(
                        null,
                        storeNewData[0]?.iqama_expiry_date_g,
                        true
                      );
                    }
                    if (tenureDays !== null) {
                      handleHighlightChange(1, tenureDays);
                    }
                  }
                }}
                className={`relative w-56 rounded-lg overflow-hidden transition-all duration-200 border-2 ${
                  !storeNewData?.[0]?.iqama_expiry_date_g
                    ? "border-gray-200 cursor-not-allowed opacity-60"
                    : highlightedDiv === 1 || (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType === 1)
                    ? "border-blue-500 shadow-xl cursor-pointer"
                    : "border-gray-300 hover:border-gray-400 shadow-md hover:shadow-lg cursor-pointer"
                } ${
                  repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeNewData?.[0]?.iqama_expiry_date_g
                    ? "cursor-not-allowed opacity-75"
                    : ""
                }`}
              >
                {/* Header - Dark Background */}
                <div style={{ backgroundColor: '#2d3748' }} className="px-3 py-2.5 text-white text-center">
                  <h3 className="text-[10px] font-bold uppercase tracking-wide leading-tight">
                    Balance Tenure<br />As Per IQAMA Expiry
                  </h3>
                </div>

                {/* Value */}
                <div className={`p-4 text-center transition-all duration-200 ${
                  !storeNewData?.[0]?.iqama_expiry_date_g
                    ? "bg-gray-50"
                    : highlightedDiv === 1 || (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType === 1)
                    ? "bg-card-sky-blue"
                    : "bg-white"
                }`}>
                  {!storeNewData?.[0]?.iqama_expiry_date_g ? (
                    <>
                      <p className="text-2xl font-bold text-gray-400 mb-1">N/A</p>
                      <p className="text-[9px] text-red-500 font-semibold uppercase px-2">Date Not Set</p>
                    </>
                  ) : (
                    <>
                      <p className="text-3xl font-bold text-gray-800 mb-1">
                        {useContractDate
                          ? (calculateDaysBetweenDates(
                              storeNewData[0]?.iqama_expiry_date_g,
                              storeNewData[0]?.end_date,
                              false
                            ) || 0)
                          : (calculateDaysBetweenDates(
                              null,
                              storeNewData[0]?.iqama_expiry_date_g,
                              true
                            ) || 0)
                        }
                      </p>
                      <p className="text-[10px] text-gray-500 uppercase font-semibold">Days</p>
                    </>
                  )}
                </div>

                {/* Footer */}
                <div className="bg-gray-100 px-3 py-1.5 text-center border-t border-gray-200">
                  <p className="text-[10px] font-bold text-gray-700 uppercase">Total</p>
                </div>
              </div>

              {/* Card 2: Balance Tenure as per NEW IQAMA Expiry Date */}
              <div
                onClick={() => {
                  if (repatrationdata?.Final_exit_status !== "OPSAUTHORISED" && storeNewData?.[0]?.Newiqamaexpiry) {
                    let tenureDays;
                    if (useContractDate) {
                      // CONTRACT END DATE - NEW IQAMA EXPIRY DATE
                      tenureDays = calculateDaysBetweenDates(
                        storeNewData[0]?.Newiqamaexpiry,
                        storeNewData[0]?.end_date,
                        false
                      );
                    } else {
                      // NEW IQAMA EXPIRY DATE - Today
                      tenureDays = calculateDaysBetweenDates(
                        null,
                        storeNewData[0]?.Newiqamaexpiry,
                        true
                      );
                    }
                    if (tenureDays !== null) {
                      handleHighlightChange(2, tenureDays);
                    }
                  }
                }}
                className={`relative w-56 rounded-lg overflow-hidden transition-all duration-200 border-2 ${
                  !storeNewData?.[0]?.Newiqamaexpiry
                    ? "border-gray-200 cursor-not-allowed opacity-60"
                    : highlightedDiv === 2 || (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType === 2)
                    ? "border-orange-500 shadow-xl cursor-pointer"
                    : "border-gray-300 hover:border-gray-400 shadow-md hover:shadow-lg cursor-pointer"
                } ${
                  repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeNewData?.[0]?.Newiqamaexpiry
                    ? "cursor-not-allowed opacity-75"
                    : ""
                }`}
              >
                {/* Header - Dark Background */}
                <div style={{ backgroundColor: '#2d3748' }} className="px-3 py-2.5 text-white text-center">
                  <h3 className="text-[10px] font-bold uppercase tracking-wide leading-tight">
                    Balance Tenure As Per<br />New IQAMA Expiry Date
                  </h3>
                </div>

                {/* Value */}
                <div className={`p-4 text-center transition-all duration-200 ${
                  !storeNewData?.[0]?.Newiqamaexpiry
                    ? "bg-gray-50"
                    : highlightedDiv === 2 || (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType === 2)
                    ? "bg-card-orange"
                    : "bg-white"
                }`}>
                  {!storeNewData?.[0]?.Newiqamaexpiry ? (
                    <>
                      <p className="text-2xl font-bold text-gray-400 mb-1">N/A</p>
                      <p className="text-[9px] text-red-500 font-semibold uppercase px-2">Date Not Set</p>
                    </>
                  ) : (
                    <>
                      <p className="text-3xl font-bold text-gray-800 mb-1">
                        {useContractDate
                          ? (calculateDaysBetweenDates(
                              storeNewData[0]?.Newiqamaexpiry,
                              storeNewData[0]?.end_date,
                              false
                            ) || 0)
                          : (calculateDaysBetweenDates(
                              null,
                              storeNewData[0]?.Newiqamaexpiry,
                              true
                            ) || 0)
                        }
                      </p>
                      <p className="text-[10px] text-gray-500 uppercase font-semibold">Days</p>
                    </>
                  )}
                </div>

                {/* Footer */}
                <div className="bg-gray-100 px-3 py-1.5 text-center border-t border-gray-200">
                  <p className="text-[10px] font-bold text-gray-700 uppercase">Total</p>
                </div>
              </div>

              {/* Card 3: Balance Tenure as per Contract */}
              <div
                onClick={() => {
                  if (repatrationdata?.Final_exit_status !== "OPSAUTHORISED" && storeNewData?.[0]?.end_date) {
                    // Card 3: Both modes => CONTRACT END DATE - Today
                    const tenureDays = calculateDaysBetweenDates(
                      null,
                      storeNewData[0]?.end_date,
                      true
                    );
                    if (tenureDays !== null) {
                      handleHighlightChange(3, tenureDays);
                    }
                  }
                }}
                className={`relative w-56 rounded-lg overflow-hidden transition-all duration-200 border-2 ${
                  !storeNewData?.[0]?.end_date
                    ? "border-gray-200 cursor-not-allowed opacity-60"
                    : highlightedDiv === 3 || (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType === 3)
                    ? "border-green-500 shadow-xl cursor-pointer"
                    : "border-gray-300 hover:border-gray-400 shadow-md hover:shadow-lg cursor-pointer"
                } ${
                  repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeNewData?.[0]?.end_date
                    ? "cursor-not-allowed opacity-75"
                    : ""
                }`}
              >
                {/* Header - Dark Background */}
                <div style={{ backgroundColor: '#2d3748' }} className="px-3 py-2.5 text-white text-center">
                  <h3 className="text-[10px] font-bold uppercase tracking-wide leading-tight">
                    Balance Tenure<br />As Per Contract
                  </h3>
                </div>

                {/* Value */}
                <div className={`p-4 text-center transition-all duration-200 ${
                  !storeNewData?.[0]?.end_date
                    ? "bg-gray-50"
                    : highlightedDiv === 3 || (repatrationdata?.Final_exit_status === "OPSAUTHORISED" && storeData?.[0]?.selectedType === 3)
                    ? "bg-card-green"
                    : "bg-white"
                }`}>
                  {!storeNewData?.[0]?.end_date ? (
                    <>
                      <p className="text-2xl font-bold text-gray-400 mb-1">N/A</p>
                      <p className="text-[9px] text-red-500 font-semibold uppercase px-2">Date Not Set</p>
                    </>
                  ) : (
                    <>
                      <p className="text-3xl font-bold text-gray-800 mb-1">
                        {calculateDaysBetweenDates(
                          null,
                          storeNewData[0]?.end_date,
                          true
                        ) || 0}
                      </p>
                      <p className="text-[10px] text-gray-500 uppercase font-semibold">Days</p>
                    </>
                  )}
                </div>

                {/* Footer */}
                <div className="bg-gray-100 px-3 py-1.5 text-center border-t border-gray-200">
                  <p className="text-[10px] font-bold text-gray-700 uppercase">Total</p>
                </div>
              </div>
            </div>
            <div>
              <>
                <div
                  className={`flex mt-4 ${isCollapsed ? "hidden" : "visible"} justify-between h-200`}
                  id="collapseWithScrollbar"
                  style={{ width: "100%" }}
                >
                  <div
                    className="overflow-x-auto"
                    style={{ backgroundColor: "white", width: "100%" }}
                  >
                    <table className="w-full divide-gray-200">
                      <thead className="bg-gray-100">
                        <tr>
                          {titles.map((columnName, index) => (
                            <th
                              key={index}
                              scope="col"
                              className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                            >
                              {columnName}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-gray-10">
                        {rowData &&
                          rowData?.map((listItem, index) => (
                            <tr key={index}>
                              <td className="px-6 py-4 whitespace-nowrap">
                                {index + 1}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  name="name"
                                  value={listItem.name}
                                  disabled={listItem.disabled === true || listItem.isFromMaster === true}
                                  onChange={(e) => {
                                    handleChange(e, index);
                                  }}
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                  placeholder="Enter description"
                                />
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  type="number"
                                  step="any"
                                  name="cost"
                                  value={listItem.cost || ""}
                                  disabled={listItem.disabled === true}
                                  onChange={(e) => {
                                    handleChange(e, index);
                                  }}
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                  placeholder="Enter cost"
                                />
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                {listItem.isFixed === true ? (
                                  <button
                                    onClick={() => handleDeleteRow(index)}
                                    style={{ backgroundColor: '#dc2626' }}
                                    className="inline-flex items-center px-3 py-1.5 text-white text-xs font-semibold rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 transition-all duration-150 shadow-sm hover:shadow-md transform hover:scale-105 active:scale-95"
                                    title="Delete this item"
                                  >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    <span className="ml-1">Delete</span>
                                  </button>
                                ) : (
                                  <input
                                    type="number"
                                    name="Basicdays"
                                    value={parseInt(listItem.Basicdays || 365)}
                                    disabled={listItem.disabled === true}
                                    onChange={(e) => {
                                      handleChange(e, index);
                                    }}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    placeholder="Enter basis days"
                                  />
                                )}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-left">
                                {listItem.isFixed === true
                                  ? parseFloat(listItem.cost || 0)
                                  : Math.round((listItem.cost / (listItem.Basicdays || 365)) * value)}
                              </td>
                            </tr>
                          ))}

                        {/* Add the total row */}
                        <tr>
                          <td className="px-6 py-4 whitespace-nowrap" colSpan="4">
                            <strong></strong>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-left text-red">
                            <strong>
                              TOTAL : {" "}
                              {Math.round(rowData.reduce(
                                (total, listItem) => {
                                  // Fixed cost rows: use direct cost value
                                  if (listItem.isFixed === true) {
                                    return total + parseFloat(listItem.cost || 0);
                                  }
                                  // Formula-based rows: calculate using Basicdays
                                  const basicDays = parseFloat(listItem.Basicdays || 365);
                                  const dailyCost = parseFloat(listItem.cost || 0) / basicDays;
                                  const calculatedCost = dailyCost * value;
                                  return total + calculatedCost;
                                },
                                0
                              ))}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Legend Section */}
                {rowData && rowData.some(item => item.isFixed === true) && (
                  <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <div className="flex items-start space-x-3">
                      <div className="flex-shrink-0">
                        <svg className="w-5 h-5 text-blue-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <h4 className="text-sm font-semibold text-blue-900 mb-2">Fixed Cost Items</h4>
                        <p className="text-xs text-blue-800 mb-2">
                          The following items use <span className="font-semibold">fixed cost</span> (no formula calculation applied):
                        </p>
                        <ul className="space-y-1">
                          {rowData
                            .filter(item => item.isFixed === true)
                            .map((item, index) => (
                              <li key={index} className="flex items-center space-x-2 text-xs text-blue-900">
                                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                                <span className="font-medium">{item.name || `Item ${index + 1}`}</span>
                                <span className="text-blue-700">- Cost: {parseFloat(item.cost || 0)}</span>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </>
              {/* <div className="text-center mt-3 ml-10">
              <h4>
                Total AMOUNT -{" "}
                {highlightedDiv === 1
                  ? "BALANCE TENURE AS PER IQAMA EXPIRY"
                  : highlightedDiv === 2
                    ? " BALANCE TENURE AS PER  NEW IQAMA EXPIRY DATE"
                    : highlightedDiv === 3
                      ? " BALANCE TENURE  AS PER CONTRACT"
                      : ""} {""}
                :  {"0"}
              </h4>
            </div> */}
            </div>

            <div className="flex items-center space-x-3 mt-4">
              <button
                onClick={() => handleAddRow()}
                className="inline-flex items-center px-6 py-2.5 bg-btn-dark text-white font-semibold text-xs uppercase rounded-lg hover:bg-btn-dark-hover focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-all duration-150 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-[1.02] active:scale-[0.98]"
                disabled={
                  rowData.length <= 0 ||
                  repatrationdata?.Final_exit_status === "OPSAUTHORISED"
                }
              >
                Add
              </button>
              <button
                onClick={() => SaveChanges()}
                className="inline-flex items-center px-6 py-2.5 bg-btn-red text-white font-semibold text-xs uppercase rounded-lg hover:bg-btn-red-hover focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all duration-150 shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-[1.02] active:scale-[0.98]"
                disabled={
                  rowData.length <= 0 ||
                  repatrationdata?.Final_exit_status === "OPSAUTHORISED"
                }
              >
                Save Changes
              </button>
              <p className="text-sm text-gray-600 ml-2">
                <span className="text-red-600 font-bold">*</span> Note: Save the changes to store the data.
              </p>
            </div>
          </>
        </div>
      </div>
    </div>
  );
}
